module.exports = __webpack_public_path__ + "img/GALERIA-XL7-2021-6.a2d7639c.jpg";